import LinearProgress from '@material-ui/core/LinearProgress';
import Multiselect from 'react-widgets/lib/Multiselect';
import Combobox from 'react-widgets/lib/Combobox';
import 'react-widgets/dist/css/react-widgets.css';
import Snackbar from '@material-ui/core/Snackbar';
import Scrollbar from 'react-scrollbars-custom';
import MuiAlert from '@material-ui/lab/Alert';
import Card from '@material-ui/core/Card';
import React, { Component } from 'react';
import '../MainContent.scss';
const isEmpty = require('is-empty');
const AWS     = require('aws-sdk');
const s3      = new AWS.S3({
	accessKeyId:     process.env.AWS_ACCESS_KEY_ID     ? process.env.AWS_ACCESS_KEY_ID     : process.env.REACT_APP_AWS_ACCESS_KEY,
	secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY ? process.env.AWS_SECRET_ACCESS_KEY : process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
	apiVersion:      '2006-03-01',
	params:          { Bucket: 'farmazon' },
});
function Alert(props) {
	return <MuiAlert elevation={6} variant='filled' {...props} />;
}

class BannerModal extends Component {
	state = {
		newImage:               null,
		newName:                '',
		baseImage:              '',
		values:                 [],
		progress:               100,
		input:                  null,
		type:                   '',
		order:                  '',
		errorProducts:          '',
		isValidProducts:        null,
		errorType:              '',
		isValidType:            false,
		errorOrder:             '',
		isValidOrder:           false,
		isValidTypeInformative: false,
		showSnackBar:           false,
		textSnackBar:           '',
		severitySnackBar:       'error',
	};

	constructor(props) {
		super(props);
		this.previewFile = this.previewFile.bind(this);
		this.changeValue = this.changeValue.bind(this);
		this.escFunction = this.escFunction.bind(this);
	}

	changeValue(newOption) {
		this.setState(
			{
				values: newOption,
			},
			() => { }
		);
	}

	escFunction(event) {
		if (event.keyCode === 27) {
			// this.onCloseModal();
			this.props.onPressCancel();
		}
	}

	componentDidMount() {
		document.addEventListener('keydown', this.escFunction, false);
	}

	componentDidUpdate(prevProps) {
		if (this.props.isVisible && prevProps.isVisible !== this.props.isVisible) {
			if (this.props.modalBannerData.id == null) {
				this.clearForm();
			}
		}
	}

	onPressCancel() {
		document.querySelector("input[type=file]").value = null;
		this.clearForm();
		this.props.onPressCancel();
	}

	clearForm() {
		this.setState({
			newImage: null,
			newName: '',
			baseImage: '',
			isVisibleAddCatgorySection: false,
			isVisibleButtonCreate: true,
			values: [],
			order: '',
			type: 'INFORMATIVO',
			modalBannerData: '',
			input: null,
			errorProducts: null,
			errorType: null,
			errorOrder: null,
		});
	}

	sendImage(file, filename) {
		const params = {
			Bucket: 'farmazon',
			Key: 'banners/' + filename,
			key: 'banners/' + filename,
			Body: file,
			ContentType: file.type,
			ACL: 'public-read',
		};

		s3.upload(params, (err, s3res) => {
			if (err) {
				console.log(err);
			} else {
				this.setState({
					newImage: s3res.Location,
				});
			}
		}).on("httpUploadProgress", function (progress) {
			var uploaded = parseInt((progress.loaded * 100) / progress.total);
			var linearProgress = document.getElementById("linearProgress");
			linearProgress.style.width = uploaded + "%";
		});
	}

	previewFile(event) {
		var file = document.querySelector("input[type=file]").files[0];
		if (file !== undefined) {
			if (file.size > 512000) {
				this.setState({
					showSnackBar:     true,
					textSnackBar:     'El archivo debe ser menor a 500 Kilobytes',
					severitySnackBar: 'error',
				});
				event.target.value = null;
				return;
			}
			if (this.IsValidImageFormat(file.name)) {
				let code_img       = file.name.split(".");
				let filename       = code_img[0] + "_" + Date.now() + "." + code_img[1];
				this.sendImage(file, filename);
				event.target.value = null;
			} else {
				window.alert("El formato de la imagen no es valido");
			}
		}
	}

	handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showSnackBar: false
		});
	};

	IsValidImageFormat(file_name) {
		let reg = /^.*\.(jpg|JPG|png|PNG)$/;
		return reg.test(file_name);
	}

	onSave() {
		if (this.props.modalBannerData.id != null) this.onUpdate();
		else this.handleOk();
	}

	clearErrors() {
		this.setState({
			errorType: null,
			errorOrder: null,
			errorProducts: null,
		});
	}

	onUpdate() {
		this.clearErrors();
		var typeBannerToUpdate =
			this.props && this.props.modalBannerData.type !== null
				? this.props.modalBannerData.dataType
				: this.state.type;
		var skuesToSend = isEmpty(this.state.values)
			? this.props.modalBannerData.skues
			: this.state.values;
		if (typeBannerToUpdate === "PRODUCTOS" && isEmpty(skuesToSend)) {
			this.setState({
				errorProducts: "Los productos son requeridos",
				isValidProducts: false,
			});
		} else {
			this.setState({
				isValidProducts: true,
			});
		}
		setTimeout(() => {
			if (this.state.isValidProducts) {
				this.props.onUpdate(
					this.props.modalBannerData.id,
					skuesToSend,
					this.state.newImage !== null
						? this.state.newImage
						: this.props.modalBannerData.url,
					this.state.order,
					typeBannerToUpdate
				);
				this.clearForm();
				this.props.onCloseModal();
			}
		}, 1000);
	}

	async handleOk() {
		await this.clearErrors();
		this.validate();
		if (
			this.state.isValidType &&
			this.state.isValidOrder &&
			this.state.isValidProducts &&
			!this.state.isValidTypeInformative
		) {
			this.createBanner();
		} else if (
			this.state.isValidType &&
			this.state.isValidOrder &&
			this.state.isValidTypeInformative
		) {
			this.createBanner();
		}
	}
	createBanner() {
		this.props.postMultipleSkuesProduct(
			this.state.values,
			this.state.newImage !== null
				? this.state.newImage
				: this.props.modalBannerData.url,
			this.state.order,
			this.state.type,
			this.state.isValid
		);
		this.clearForm();
		this.props.onCloseModal();
	}

	validate() {
		if (this.state.type === null || isEmpty(this.state.type)) {
			this.setState({
				errorType: "El tipo de Banner es requerido",
			});
		} else {
			this.setState({
				isValidType: true,
			});
		}
		if (this.state.order === "") {
			this.setState({
				errorOrder: "El número de ordenamiento es requerido",
				isValidOrder: false,
			});
		} else {
			this.setState({
				isValidOrder: true,
			});
		}
		if (this.state.type === "PRODUCTOS" && isEmpty(this.state.values)) {
			this.setState({
				errorProducts: "Los productos son requeridos",
				isValidProducts: false,
			});
		} else {
			this.setState({
				isValidProducts: true,
			});
		}
		if (this.state.type === "INFORMATIVO") {
			this.setState({
				isValidTypeInformative: true,
				values: [],
			});
		} else {
			this.setState({
				isValidTypeInformative: false,
			});
		}
	}

	onChangeOrder(e) {
		this.setState({
			order: e.target.value,
		});
	}

	onDelete() {
		this.props.onDelete(this.props.modalBannerData.id);
	}

	onChangeType(newOption) {
		this.props.modalBannerData.dataType = newOption;
		this.setState({
			type: newOption,
		});
	}

	render() {
		var labelImage = null;
		if (this.props.modalBannerData) {
			labelImage = this.state.newImage
				? this.state.newImage
				: this.props.modalBannerData.url == null
					? ""
					: this.props.modalBannerData.url;
		}
		return (
			<div className={this.props.isVisible ? "modal display-block" : "modal display-none"}>
				<div className="modal-center-main">
					<Scrollbar style={{ width: "80%", height: "100%" }}>
						<center>
							{this.props.modalBannerData && this.props.modalBannerData.id != null && (
								<h3 className="bold2">ACTUALIZACIÓN DE LA IMAGEN.</h3>
							)}
							{this.props.modalBannerData && this.props.modalBannerData.id == null && (
								<h2 className="bold2">SUBIR IMAGEN.</h2>
							)}
							{this.props.modalBannerData && (
								<img
									src={
										this.state.newImage
											? this.state.newImage
											: this.props.modalBannerData.url
									}
									width="80%"
									alt={labelImage}
								/>
							)}
							<br/>
							<br/>
							<input
								type="file"
								id="theFile"
								accept=".jpg, .jpeg, .png"
								onChange={this.previewFile.bind(this)}
							/>
							<LinearProgress
								id="linearProgress"
								variant="determinate"
								value={this.state.progress}
							/>
							<br/>
							<Card>
								<h6 style = {{ fontSize: "14px" }}><b>Consideraciones:</b></h6>
								<small style = {{ fontSize: "10px" }}>
									<b>° Tamaño máximo permitido: </b> 500 KB (kilobytes) <br/>
									<b>° Formato de imagen: </b> .png <br/>
									<b>° Tamaño de imagen: </b> 3108x886 px
								</small>
								<br/><br/>
							</Card>
							<br/>
							{this.props.modalBannerData && labelImage && (
								<div className="row-multiselect-roles">
									<div className="auth-label">
										TIPO DE BANNER
										<span className="required"> * </span>
										<Combobox
											className="select-roles"
											data={["PRODUCTOS", "INFORMATIVO"]}
											error={this.state.errorType}
											defaultValue={
												this.props && this.props.modalBannerData.type !== null
													? this.props.modalBannerData.dataType
													: this.state.type
											}
											onChange={this.onChangeType.bind(this)}
										/>
									</div>
								</div>
							)}
							{this.props.products && this.props.modalBannerData && labelImage && (
								<div className="auth-label">
									NUMERO DE ORDENAMIENTO
									<span className="required"> * </span>
									<input
										id="nombreForm"
										ref={(el) => {
											this.orderForm = el;
										}}
										onChange={this.onChangeOrder.bind(this)}
										value={this.state.order}
										error={this.state.errorOrder}
										type="number"
										placeholder={
											this.props.modalBannerData.order
												? this.props.modalBannerData.order
												: "Ej.: 100"
										}
										className="local-store-input"
									/>
								</div>
							)}
							<div className="auth-error">{this.state.errorOrder}</div>
							{this.props.products &&
								this.props.modalBannerData &&
								labelImage &&
								this.props.modalBannerData.dataType === "PRODUCTOS" && (
									<div className="auth-label">
										PRODUCTOS
										<span className="required"> * </span>
										<Multiselect
											error={this.state.errorProducts}
											placeholder="Productos disponibles"
											data={this.props.products.productos}
											valueField="sku"
											textField="descripcion"
											filter="contains"
											defaultValue={this.props.modalBannerData.skues}
											onChange={(newOption) => {
												this.changeValue(newOption);
											}}
										/>
									</div>
								)}
							<div className="auth-error">{this.state.errorProducts}</div>
							<br/>
							<br/>
							<div className="modal-activity-section">
								{labelImage && (
									<button
										className="modal-buttonOK"
										onClick={this.onSave.bind(this)}
									>GUARDAR</button>
								)}
								{labelImage && this.props.modalBannerData.id && (
									<button
										className="modal-buttonDelete"
										onClick={this.onDelete.bind(this)}
									>ELIMINAR</button>
								)}
								<button
									className="modal-buttonNo"
									onClick={this.onPressCancel.bind(this)}
								>CERRAR</button>
							</div>
						</center>
					</Scrollbar>
					{
						<Snackbar open={this.state.showSnackBar} autoHideDuration={6000} onClose={this.handleClose}>
							<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
								{this.state.textSnackBar}
							</Alert>
						</Snackbar>
					}
				</div>
			</div>
		);
	}
}

export default BannerModal;
